import { createAction } from '@reduxjs/toolkit';

/** Identifies this browsing context among the tabs sharing the sync channel. */
export const CONVERSATION_DRAFTS_TAB_ID = `${Date.now()}-${Math.random()}`;

/** Announces that this tab wrote a draft. Broadcast to the other tabs. */
export const conversationDraftsChanged = createAction<{
  readonly tabId: string;
}>('conversationDrafts/changed');
